import { TransactionType } from '@seapoint/server/enums';
import { exhaustiveCheck } from './exhaustive-check';

export const getTransactionTypeDescription = (transactionType: TransactionType) => {
  switch (transactionType) {
    case TransactionType.CARD_PAYMENT:
      return 'Card payment';
    case TransactionType.CARD_REFUND:
      return 'Card refund';
    case TransactionType.CARD_CHARGEBACK:
      return 'Chargeback';
    case TransactionType.EXCHANGE:
      return 'Exchange';
    case TransactionType.DIRECT_DEBIT:
      return 'Direct debit';
    case TransactionType.TRANSFER:
      return 'Bank transfer';
    case TransactionType.REFUND:
      return 'Refund';
    case TransactionType.OTHER:
      return 'Other';
    default:
      return exhaustiveCheck(transactionType);
  }
};
